import { ReactNode, memo } from "react";

import { DemoProvider } from "contexts/demo";
import { MenuProvider } from "contexts/menu";
import { ThemeProvider } from "contexts/theme";
import { LoadingProvider } from "contexts/loading";
import { SelectedTimeRangeProvider } from "contexts/timed-chunk";
import { TimeRangeProvider } from "contexts/time-range";

const CustomContexts = memo(({ children }: { children: ReactNode }) => {
  return (
    <TimeRangeProvider>
      <SelectedTimeRangeProvider>
        <LoadingProvider>
          <ThemeProvider>
            <MenuProvider>
              <DemoProvider>{children}</DemoProvider>
            </MenuProvider>
          </ThemeProvider>
        </LoadingProvider>
      </SelectedTimeRangeProvider>
    </TimeRangeProvider>
  );
});

export default CustomContexts;
